import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { BulkActionService, IBulkActionInfoModel, IBulkActionInfoItemModel, BulkActionState, BulkActionTargetType } from '../services/bulk-action.service';

@Component({
	template: require('./sm-jobreport.component.html')
})
export class SmJobreportComponent implements OnInit {

	items: IBulkActionInfoItemModel[];
	actionName: string;
	startAt: Date;
	endAt: Date;
	stateName: string;
	successCount: number;
	allCount: number;

	backToOffers: boolean;
	backToTemplates: boolean;
	backToTransactions: boolean;
	itemRoutePrefix: string;

	constructor(
		private _bulkActionService: BulkActionService,
		private _route: ActivatedRoute) {
	}

	ngOnInit() {
		let actionGuid = this._route.snapshot.params['guid'];

		this._bulkActionService
			.getBulkActionInfo(actionGuid)
			.subscribe(model => {
				this.items = model.items;
				this.actionName = model.actionName;
				this.startAt = model.startAt;
				this.endAt = model.endAt;
				this.successCount = model.items.filter(x => x.state == BulkActionState.Done).length;
				this.allCount = model.items.length;

				let itemType = model.items[0].targetType;
				switch (itemType) {
					case BulkActionTargetType.Template:
						this.backToTemplates = true;
						this.itemRoutePrefix = '/sm/templates/detail';
						break;
					case BulkActionTargetType.Offer:
						this.backToOffers = true;
						this.itemRoutePrefix = '/sm/offers/detail';
						break;
					case BulkActionTargetType.Transaction:
						this.backToTransactions = true;
						this.itemRoutePrefix = '/sm/transactions/detail';
						break;
					default:
				}
			});
	}

}


// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader!./app/shared/components/sm-jobreport.component.ts